module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable14.116200de.jpg";